import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react-lite';

import {
  Button,
  Text,
} from 'spindl-shared-components';

import styles from './ModalAttachmentContent.module.scss';
import usePresenter from './ModalAttachmentContent.presenter';
import getProps from './ModalAttachmentContent.props';
import { ModalAttachmentContentCombinedProps } from './types';


// MANUAL OVERRIDE - converted to observer Component
const ModalAttachmentContent: React.FC<ModalAttachmentContentCombinedProps> = observer((props) => {
  const {
    state,
    className,
    classes,
    button,
    text,
    button1,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`modalAttachmentContent${variantName}`];

  let componentView;

  switch (variantName) {
    case 'Default':
    case 'Error': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}
          />
        </div>
      );
      break;
    }
    case 'Expanded': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}
          />
          <div className={cx(styles.mainContent, classes?.mainContent)}>
            <div className={cx(styles.bottomContent, classes?.bottomContent)}>
              <Text
                className={cx(styles.text, classes?.text)}
                {...internalProps.text}
                {...text}
              />
              <Button
                className={cx(styles.button1, classes?.button1)}
                {...internalProps.button1}
                {...button1}
              />
            </div>
          </div>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
}); // MANUAL OVERRIDE

export default ModalAttachmentContent;
